/**
 * @module app.ext.mcg-informed
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IAssessmentsConfig, ITasksConfig } from 'app/core/models/essette-interfaces';
import { ISmartTaskBinding, ITaskContainer } from 'app/core/components/tasks/task';
import { AssessmentService } from 'app/core/services/assessment-service';
import { apiCall } from 'app/shared/lib/api/api';
import { IAssessmentAttachmentOptions } from 'app/ext/mcg-informed/assessment-attachment';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class SmartAssessment extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    protected task!: Core.Task;
    protected targetId!: string;
    protected tasksConfig: ITasksConfig = {};
    protected assessmentsConfig: IAssessmentsConfig = {};

    private container!: ITaskContainer;
    protected readonly: boolean = false;

    protected attachmentId: string | null = null;
    protected options: IAssessmentAttachmentOptions | null = null;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly service: AssessmentService,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async activate(params: ISmartTaskBinding): Promise<void> {
        this.logger.debug('activate', params);

        if(!params || !params.container || !params.targetId || !params.task || !params.task.id || !params.tasksConfig || !params.tasksConfig.smartTasksConfig || !params.tasksConfig.smartTasksConfig.assessmentsConfig) {
            throw TypeError(`${SmartAssessment.name} Component Model not Bound.`);
        }

        this.targetId = params.targetId;
        this.tasksConfig = params.tasksConfig;

        this.options = {
            showToc: false,
            showBack: false,
            showActions: true,
            showMember: false,
            showMemberSummaryLink: false,
            showTarget: false,
            showTargetSummaryLink: false,
            stickyActions: false
        }

        this.assessmentsConfig = {
            ...params.tasksConfig.smartTasksConfig.assessmentsConfig,
        };

        this.state = params.state || this.state;

        this.task = params.task;
        this.container = params.container;
        this.readonly = params.readonly;

        this.service.configure(this.assessmentsConfig);
        await this.loadAttachment(this.task.id!);
    }

    ////****************** Events ***************************************************////

    protected completeAssessment(): void {
        if(this.container) this.container.completeTask(true);
    }

    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

    @apiCall
    private async loadAttachment(taskId: string, targetId?: string): Promise<void> {
        try {
            this.state.beginLoad();
            const response = await this.service.loadAttachmentByTask(taskId, undefined, targetId);
            if(!response.isSuccessful || response.results.length === 0) return;

            this.attachmentId = response.results[0].id || null;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }

}
